import { RouteRecordRaw } from "vue-router";

export const staffRoutes: RouteRecordRaw[] = [
  {
    path: "/staff",
    meta: {
      requiresStaff: true,
    },
    children: [
      {
        path: "users",
        name: "staffUsers",
        component: () => import("../../views/staff/Users.vue"),
        meta: {
          pageHeader: "page_headers.staff_users",
        },
      },
      {
        path: "files",
        name: "staffFiles",
        component: () => import("../../views/staff/Files.vue"),
        meta: {
          pageHeader: "page_headers.staff_files",
        },
      },
    ],
  },
];
